import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import {useGeneralInputSpecialCase} from "../../../../hooks/use-general-input.js";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const specialInputHandler = useGeneralInputSpecialCase(setFilters);

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>
                    <InputDateTime
                        id="dtStart"
                        label="Data/hora inicial *"
                        selected={filters.dtStart}
                        onChange={date => specialInputHandler("dtStart", date)}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />
                    <InputDateTime
                        id="dtEnd"
                        label="Data/hora final *"
                        selected={filters.dtEnd}
                        onChange={date => specialInputHandler("dtEnd", date)}
                        classNameWrapper={"w-full"}
                        dateFormat="LL"
                    />
                </form>
            </div>
        </>
    );
};

export default Filters;